import { render } from "./SideMenu.vue?vue&type=template&id=5b7a33a8"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/manager/SideMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b7a33a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b7a33a8', __exports__)) {
    api.reload('5b7a33a8', __exports__)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=5b7a33a8", () => {
    api.rerender('5b7a33a8', render)
  })

}


export default __exports__